import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { H3, H4 } from "../../../../AbstractElements";

import { useTranslation } from "react-i18next";
import { ContactContext, SocialDataContext } from "../../ContextProvider";

import InputError from "../../../../Shared/Components/Form/InputError";
import InputLinkedin from "../../../../Shared/Components/Form/Inputs/InputLinkedin";

import InputWebSiteUrl from "../../../../Shared/Components/Form/Inputs/InputWebSiteUrl";
import InputFacebook from "../../../../Shared/Components/Form/Inputs/InputFacebook";
import InputInstagramUrl from "../../../../Shared/Components/Form/Inputs/InputInstagramUrl";
import InputInstagramUsername from "../../../../Shared/Components/Form/Inputs/InputInstagramUsername";
import InputTwitterUrl from "../../../../Shared/Components/Form/Inputs/InputTwitterUrl";
import InputTwitterUsername from "../../../../Shared/Components/Form/Inputs/InputTwitterUsername";

const SocialNetworks = ({ contactId, register, errors, reset, setValue }) => {
  const { t } = useTranslation("translation");

  //context
  const { item: contactData, successUpdated } = useContext(ContactContext);
  const { item, apiErrors, setItem, getItem, setApiErrors } =
    useContext(SocialDataContext);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {}, []);

  useEffect(() => {
    setValue("facebook_url", item?.facebook_url);
    setValue("linkedin_url", item?.linkedin_url);
    setValue("instagram_url", item?.instagram_url);
    setValue("website_url", item?.website_url);
    setValue("instagram_username", item?.instagram_username);
    setValue("twitter_url", item?.twitter_url);
    setValue("twitter_username", item?.twitter_username);
  }, [item]);

  useEffect(() => {
    contactId ? getItem(contactId) : setItem({});
  }, [contactId]);

  useEffect(() => {
    setValue("contact_id", contactData?.id);
  }, [contactData]);

  useEffect(() => {
    return () => {
      setItem({});
      setApiErrors([]);
    };
  }, []);
  return (
    <Fragment>
      <Card>
        <CardBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <div className="product-info">
            {<H3>Redes sociales</H3>}

            <Row>
              <Col sm="6">
                <H4 attrH4={{ className: "mt-4" }}>Facebook</H4>
                <div className="product-group">
                  <FormGroup>
                    <Label> {t("URL Perfil")}</Label>
                    <InputFacebook
                      errors={errors}
                      register={register}
                    ></InputFacebook>
                    <InputError errors={errors} name="facebook_url" />
                  </FormGroup>
                </div>
              </Col>

              <Col sm="6">
                <H4 attrH4={{ className: "mt-4" }}>LinkedIn</H4>
                <div className="product-group">
                  <FormGroup>
                    <Label> {t("URL Perfil")}</Label>
                    <InputLinkedin
                      errors={errors}
                      register={register}
                    ></InputLinkedin>
                    <InputError errors={errors} name="linkedin_url" />
                  </FormGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <H4 attrH4={{ className: "mt-4" }}>Instagram</H4>
                <div className="product-group">
                  <FormGroup>
                    <Label> {t("URL Perfil")}</Label>
                    <InputInstagramUrl
                      errors={errors}
                      register={register}
                    ></InputInstagramUrl>
                    <InputError errors={errors} name="instagram_url" />
                  </FormGroup>

                  <FormGroup>
                    <Label> {t("Usuario")}</Label>
                    <InputInstagramUsername
                      errors={errors}
                      register={register}
                    ></InputInstagramUsername>
                    <InputError errors={errors} name="instagram_username" />
                  </FormGroup>
                </div>
              </Col>

              <Col sm="6">
                <H4 attrH4={{ className: "mt-4" }}>Twitter / X</H4>
                <div className="product-group">
                  <FormGroup>
                    <Label> {t("URL Perfil")}</Label>
                    <InputTwitterUrl
                      errors={errors}
                      register={register}
                    ></InputTwitterUrl>
                    <InputError errors={errors} name="twitter_url" />
                  </FormGroup>

                  <FormGroup>
                    <Label> {t("Usuario")}</Label>
                    <InputTwitterUsername
                      errors={errors}
                      register={register}
                    ></InputTwitterUsername>
                    <InputError errors={errors} name="twitter_username" />
                  </FormGroup>
                </div>
              </Col>
            </Row>
            <Row></Row>
            <Col sm="6">
              <H4 attrH4={{ className: "mt-4" }}>Sitio web</H4>
              <div className="product-group">
                <FormGroup>
                  <Label> {t("URL")}</Label>
                  <InputWebSiteUrl
                    errors={errors}
                    register={register}
                  ></InputWebSiteUrl>
                  <InputError errors={errors} name="website_url" />
                </FormGroup>
              </div>
            </Col>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default SocialNetworks;
